import React, { MutableRefObject, ReactNode, useEffect, useState } from 'react';
import SimpleBarCore from 'simplebar-core';
import SimpleBar from 'simplebar-react';
import { Flexer } from '../app/dashboard/elements/LayoutElements';
import { remInPx } from './Utils';

export interface ScrollerValues {
    clientWidth: number;
    clientHeight: number;
    scrollTop: number;
    scrollHeight: number;
    top: number;
}

export const ScrollerValues = {
    for(elmt: HTMLElement): ScrollerValues {
        return {
            clientWidth: elmt.clientWidth,
            clientHeight: elmt.clientHeight,
            scrollTop: elmt.scrollTop,
            scrollHeight: elmt.scrollHeight,
            top: elmt.scrollTop / (elmt.scrollHeight - elmt.clientHeight),
        };
    }
};

export type ScrollerInteral = SimpleBarCore;

export type FlexScrollerProps = {
    internalRef?: MutableRefObject<ScrollerInteral>,
    autoHide?: boolean,
    maxHeight?: string | number,
    children: ReactNode,
    onScroll?: (values: ScrollerValues) => void,
};

export const FlexScroller = ({ internalRef, autoHide, maxHeight, children, onScroll }: FlexScrollerProps) => {
    onScroll = onScroll ?? (() => { });
    const [core, setCore] = useState<SimpleBarCore>();

    useEffect(() => {
        if (!core) return;
        if (internalRef) internalRef.current = core;
        const sh = (e) => onScroll(ScrollerValues.for(e.target as HTMLElement));
        core.getScrollElement().addEventListener('scroll', sh);
        return () => core.getScrollElement().removeEventListener('scroll', sh);
    }, [core]);

    const scrollerStyle = {
        height: '100%',
        maxHeight: !!maxHeight ? remInPx(maxHeight) : 'auto'
    };

    return <Flexer className="blockWheel" relative grow>
        <Flexer absolute inset="0">
            <SimpleBar ref={setCore} autoHide={autoHide ?? true} style={scrollerStyle}>
                {children}
            </SimpleBar>
        </Flexer>
    </Flexer>;
};

export type FixedScrollerProps = FlexScrollerProps & { height?: string | number };

export const FixedScroller = ({ internalRef, autoHide, height, maxHeight, children, onScroll }: FixedScrollerProps) => {
    onScroll = onScroll ?? (() => { });
    const [core, setCore] = useState<SimpleBarCore>();

    useEffect(() => {
        if (!core) return;
        if (internalRef) internalRef.current = core;
        const sh = (e) => onScroll(ScrollerValues.for(e.target as HTMLElement));
        core.getScrollElement().addEventListener('scroll', sh);
        return () => core.getScrollElement().removeEventListener('scroll', sh);
    }, [core]);

    const scrollerStyle = {
        width: '100%',
        height: '100%',
        maxHeight: !!maxHeight ? remInPx(maxHeight) : 'auto'
    };

    return <Flexer className="blockWheel" height={height} maxHeight={maxHeight}>
        <SimpleBar ref={setCore} autoHide={autoHide ?? true} style={scrollerStyle}>
            {children}
        </SimpleBar>
    </Flexer>;
};
